"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipConditional = void 0;
var react_1 = __importDefault(require("react"));
var _1 = require(".");
/**
 * Simple wrapper for Tooltip to strip it from DOM if there is no tooltip content.
 * Maybe this could be the default Tooltip. But it's safer to have it as opt-in to not break anything.
 */
var TooltipConditional = function (_a) {
    var content = _a.content, children = _a.children, restProps = __rest(_a, ["content", "children"]);
    return content && children ? (react_1.default.createElement(_1.Tooltip, __assign({ content: content }, restProps), children)) : (react_1.default.createElement(react_1.default.Fragment, null, children));
};
exports.TooltipConditional = TooltipConditional;
